import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IInquiryCndsState, ICod0102mState, IMenuTreeState, IMenuState, IAuthState, IMenuAuthState} from '../../models/cod/cod0102m_model';
 
const initialState: ICod0102mState = {
    menuTree        : [],   //메뉴목록
    originMenuInfo  : [],   //메뉴상세(원본백업)
    menuInfo        : [],   //메뉴상세(화면수정용)
    menuAuthMap     : [],   //메뉴권한목록(원본백업)
    authrtyIdList   : [],   //권한목록 
    maxLvl          : '',   //depth 제한

    selectedMenuId  : '',   //현재선택메뉴 
    modifiedAuthMap : {},   //선택된메뉴권한(화면수정용)

        
    inquiryCnds: {          //조회조건
        authrtyId   : '',   //권한ID 
    },
};

export const cod0102m_Slice = createSlice({
    name: 'cod0102m_Slice',
    initialState,
    reducers: {
        setMenuTree: (state, action:PayloadAction<IMenuTreeState[]>) => {
            state.menuTree = action.payload;
        },
        setMenuInfo: (state, action:PayloadAction<IMenuState[]>) => {
            state.menuInfo       = action.payload;      //화면수정용
            if (state.originMenuInfo.length === 0) {    //서버에서 가져온 원본
                state.originMenuInfo = action.payload.map(item => ({ ...item }));
            }
        },
        setMenuAuthMap: (state, action: PayloadAction<IMenuAuthState[]>) => {
            state.menuAuthMap = action.payload;
        },
        addMenu: (state, action) => {
            state.menuInfo.push(action.payload);
        },
        clearOriginInfo: (state) => {
            state.originMenuInfo = [];
        },
        setAuthrtyIdList: (state, action:PayloadAction<IAuthState[]>) => {
            state.authrtyIdList = action.payload;
        },
        setModifiedAuthMap: (state, action: PayloadAction<{ menuId: string, authIds: string[] }>) => {
            const { menuId, authIds } = action.payload;
            state.modifiedAuthMap = {
                 ...state.modifiedAuthMap,
                 [menuId]: authIds
            };
         },
        clearModifiedAuthMap: (state) => {
            state.modifiedAuthMap = {};
         },
        setMaxLvl: (state, action:PayloadAction<string>) => {
            state.maxLvl = action.payload;
        },
        setSelectedMenuId: (state, action:PayloadAction<string>) => {
            state.selectedMenuId = action.payload;
        },
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
    },
});

export default cod0102m_Slice.reducer;
export const Cod0102mAction  = cod0102m_Slice.actions;
export const Cod0102mReducer = cod0102m_Slice.reducer;
